import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { IRefund } from "../../financial.types";
import { requestRefundById } from "./refundById.request";

const useRefundById = (
  id?: string | null,
  options?: QueryOptions<IRefund, ApiServiceError<ApiError>>
) => {
  const { data: refund, ...rest } = useQuery({
    queryKey: ["refunds", id],
    queryFn: async () => await requestRefundById(String(id)),
    enabled: !!id,
    ...options
  });

  return { refund, ...rest };
};

export default useRefundById;
